import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import _ from 'lodash'
import {RightsWrapper} from '../../components/_utils/utils'
import styles from '../Template/all/styles.less'

const TabPane = Tabs.TabPane
let accountPaymentCompanies = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies:'';
@Form.create()

class SupportStaffSalary extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    shiftTiming:[],
    allUsers: [],
    workingDays:[{id:"Monday", display:"Monday"}, {id:"Tuesday",display:"Tuesday"}, {id:"Wednesday", display:"Wednesday"},
                  {id:"Thursday", display:"Thursday"}, {id:"Friday", display:"Friday"}, {id:"Saturday", display:"Saturday"}, {id:"Sunday", display:"Sunday"}]
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getSupportStaffSalary({
        ...params,
        regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateSupportStaffSalary(values)
          // x = await Request.updateStaffSalaryList(values)
        } else {
          x = await Request.addSupportStaffSalary(values)
        //   x = await Request.addStaffSalaryList(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Support Staff Salary Updated Successfully`
              : 'Support Staff Salary Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteSupportStaffSalary = async data =>{
    this.setState({loading:true})
    await Request.deleteSupportStaffSalary(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  // deleteStaffSalaryList = async data => {
  //   this.setState({loading: true})
  //   await Request.deleteStaffSalaryList(data)

  //   this.setState({loading: false})

  //   this.table.current.reload()

  //   notification.success({
  //     message: 'Deleted Successfully',
  //     duration: 20,
  //     key: `${data._id}-close`
  //   })
  // }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setSupportStaffSalaryData(staffSalaryId) {
    if(staffSalaryId) {
      Request.supportStaffSalaryById({id:staffSalaryId}).then(({doc,error,message})=>{
        if(!error && doc) {
          this.setState({
            id: doc._id,
            activeTab: '1'
          })
          this.props.form.setFieldsValue({
            name: doc.name,
            staffSalary: doc.staffSalary,
            empId:doc.empId,
            joiningSalary:doc.joiningSalary
          })
        }else {
          notification.error({
            message:'Error Getting Data'
          })
        }
      })
    }
  }

  // setStaffSalaryListData(staffSalaryId) {
  //   if (staffSalaryId) {
  //     Request.staffSalaryByID({id: staffSalaryId}).then(
  //       ({doc, error, message}) => {
  //         if (!error && doc) {
  //           this.setState({
  //             id: doc._id,
  //             activeTab: '1'
  //           })
  //           let timing = doc.shiftTiming.split(' - ')
  //           this.props.form.setFieldsValue({
  //             staffId: doc.staffId,
  //             staffSalary: doc.staffSalary,
  //             shiftTiming:doc.shiftTiming,
  //             workingDays:doc.workingDays
  //           })
  //         } else {
  //           notification.error({
  //             message: 'Error Getting Data',
  //             description: message
  //           })
  //         }
  //       }
  //     )
  //   }
  // }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  loadShiftTiming = async() =>{
    let params = {
      results:1000,
      count:1000
    }
    let response = await Request.getAllShiftTimings(params)
    let shiftTiming = []
    _.each(response.data, (item)=>{
      shiftTiming.push({id:item.shiftTime, display:item.shiftTime})
    })
    this.setState({shiftTiming:shiftTiming})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
    this.loadShiftTiming()
    let localUser = JSON.parse(localStorage.getItem("user"));
    
    let { data: allUsers } = await Request.loadDeskUser({
      results: 10000,
      active: true,
      // userBranch: localUser ? localUser.userBranch : null
    });
    this.setState({ allUsers });
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    let accountPaymentCompaniesArray = [];
    if(accountPaymentCompanies.indexOf(',')) {
      accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
    }
    const {id, workingDays, shiftTiming} = this.state;


    const inputTypes = {
        fields:[
            {
                label:'Member Name',
                key:'name',
                type:'text',
                required:true
            },
            {
              label:'Father Name',
              key:'fatherName',
              type:'text',
              required:true
            }, 
            {
                label:'Staff Salary',
                key:'staffSalary',
                required:true
            },
            {
              label:'Joining Salary',
              key:'joiningSalary',
              type:'number',
              required:true
            },
            {
              label:'Company',
              key:'company',
              type:'select',
              required:true,
              options:accountPaymentCompaniesArray,
              onChange:v =>{
                this.props.form.setFieldsValue({company:v})
              }
            },
            {
                label:'Employee Id',
                key:'empId',
                type:'text'
            },
            
        ]
    }

    // const inputTypes1 = {
    //   fields: [
    //     {
    //       label: "Staff Member",
    //       key: "staffId",
    //       type: "select",
    //       showSearch: true,
    //       required: true,
    //       allowClear: true,
    //       keyAccessor: (x) => x._id,
    //       valueAccessor: (x) => x.name,
    //       options: this.state.allUsers ? this.state.allUsers : {},
    //       onChange: (v) => {
    //         this.props.form.setFieldsValue({ staffId: v });
    //       },
    //     },
    //     {
    //       label: 'Staff Salary',
    //       key: 'staffSalary',
    //       required: true,
         
    //     },
    //     {
    //       label:'Shift Timing',
    //       key:'shiftTiming',
    //       type:'select',
    //       options:shiftTiming,
    //       required:true,
    //       onChange:v=>{
    //         this.props.form.setFieldsValue({shiftTiming:v})
    //       }
    //     },
    //     {
    //       label:'Working Days',
    //       key:'workingDays',
    //       required:true,
    //       type:'select',
    //       options:workingDays,
    //       mode:'multiple',
    //       onChange:v=>{
    //         this.props.form.setFieldsValue({workingDays:v})
    //       }
    //     }
    //   ]
    // };

    const columns = [
      {
        title: 'Staff Member',
        key: 'name',
        render: (text, record) => {
          return(<div>{record.name}</div>)
        }
      },
      {
        title:'Father Name',
        key:'fatherName'
      },
      // {
      //   title:'Department',
      //   key:'department',
      //   render:(text,record)=>{
      //     return(<div>{record.staffId.department}</div>)
      //   }
      // },
      {
        title: 'Staff Salary',
        key: 'staffSalary'
      },
      {
        title:'Company',
        key:'company'
      },
      {
        title:'Joining Salary',
        key:'joiningSalary'
      },
      {
        title:'Employee Id',
        key:'empId'
      },
      // {
      //   title:'Working Days',
      //   key:'workingDays',
      //   render:(text,record)=>(
      //     <span>{text}</span>
      //   )
      // },
      // {
      //   title:'Shift Timing',
      //   key:'shiftTiming'
      // },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title:'Action',
        key:'operation',
        render:(text,record)=>(
          <React.Fragment>
            <Tooltip title="Edit Support Staff Salary">
            <Button
              className={styles.btn}
              shape='circle'
              icon='edit'
              onClick={()=>{
                this.setSupportStaffSalaryData(record._id)
              }}
            />
            </Tooltip>
            <Tooltip title="Delete Support Staff Salary">
              <Popconfirm
                title="Are you Sure You want to delete Support Staff Salary"
                onConfirm={() => {
                  this.deleteSupportStaffSalary({_id: record._id})
                }}
                okText="Yes"
                cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
              </Popconfirm>
            </Tooltip>
          </React.Fragment>

        )
      }
      // {
      //   title: 'Action',
      //   key: 'operation',
      //   render: (text, record) => (
      //     <React.Fragment>
      //       <RightsWrapper myRight={'staffSalaryManagement.edit'}>
      //         <Tooltip title="Edit Staff Salary">
      //           <Button
      //             className={styles.btn}
      //             shape="circle"
      //             onClick={() => {
      //               this.setStaffSalaryListData(record._id)
      //             }}
      //             icon="edit"
      //           />
      //         </Tooltip>
      //       </RightsWrapper>
      //       <RightsWrapper myRight={'staffSalaryManagement.delete'}>
      //         <Tooltip title="Delete Staff Salary">
      //           <Popconfirm
      //             title="Are you sure delete this Staff Salary?"
      //             onConfirm={() => {
      //               this.deleteStaffSalaryList({_id: record._id})
      //             }}
      //             okText="Yes"
      //             cancelText="No">
      //             <Button
      //               className={styles.btn}
      //               shape="circle"
      //               icon="delete"
      //             />
      //           </Popconfirm>
      //         </Tooltip>
      //       </RightsWrapper>
      //     </React.Fragment>
      //   )
      // }
    ]
    return (
      <PageHeaderWrapper title={` Support Staff Salary `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All List`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Staff Salary'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default SupportStaffSalary
